import React, { useEffect, useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import { ThreeDots } from "react-loader-spinner";
import logo from "../../../assets/communityXlogo.svg";
import subHeadingImage from "../../../assets/business profile logo.svg";
import copyIcon from "../../../assets/copy icon.svg";
import regnerateIcon from "../../../assets/regenerate icon.svg";
import ErrorLabel from "../../../ErrorLabel/ErrorLabel";
import { PromoteCampaignAPI } from "../../API/ShopLocalAIAPI/PromoteCampaignAPI";
import { useNavigate } from "react-router-dom";
import MultiSelectDropdown from "../../MultiSelectDropdown/MultiSelectDropdown";
import SelectDropdown from "../../SelectDropdown/SelectDropdown";
import swal from "sweetalert";
import Loader from "../../Loader/Loader";

const PromoteCampaign = () => {
  const [formData, setFormData] = useState({
    eventType: "",
    campaignType: "",
    holiday: "",
    sentimentType: [],
    offerName: "",
  });
  const [loading, setLoading] = useState(false);
  const eventOptions = [
    { name: "Email Campaign", id: 1 },
    { name: "Social Media Campaign", id: 2 },
  ];
  const holidayOptions = [
    { name: "New Year", id: 1 },
    { name: "Valentine's Day", id: 2 },
    { name: "Spring Break", id: 3 },
    { name: "Labor Day", id: 4 },
    { name: "Mother's Day", id: 5 },
    { name: "Father's Day", id: 6 },
    { name: "4th of July", id: 7 },
    { name: "Memorial Day", id: 8 },
    { name: "Thanksgiving", id: 9 },
    { name: "Halloween", id: 10 },
    { name: "Christmas", id: 11 },
  ];
  const campaignOptions = [
    { name: "New Year Sale", id: 1 },
    { name: "Spring", id: 2 },
    { name: "Summer", id: 3 },
    { name: "Fall", id: 4 },
    { name: "New Service", id: 5 },
    { name: "New Product", id: 6 },
    { name: "Holiday Sale", id: 7 },
    { name: "Year End Sales", id: 8 },
  ];
  const sentimentOptions = [
    { name: "Excitement", id: "1" },
    { name: "Value", id: "2" },
    { name: "Exclusive", id: "3" },
    { name: "Luxury", id: "4" },
    { name: "Joy", id: "5" },
    { name: "Adventure", id: "6" },
    { name: "Personalized", id: "7" },
    { name: "Celebration", id: "8" },
    { name: "Gratitude", id: "9" },
    { name: "Rewarding", id: "10" },
  ];

  const navigate = useNavigate();

  // form data error values
  const [errorLabelName, setErrorLabelName] = useState({
    eventType: "",
    holiday: "",
    campaignType: "",
    sentiment: "",
  });

  // state to show response section
  const [isCheck, setIsCheck] = useState(false);

  // state to toggle between loading lines in button
  const [rotatorLine, setRotatorLine] = useState(false);

  // state to show response generated
  const [responseGenerated, setResponseGenerated] = useState("");

  // state to copy the response in the clipboard
  const [copyTextField, setCopyTextField] = useState(false);

  ////////////// response generator function //////////////
  const responseGenerator = async () => {
    if (
      formData.eventType &&
      formData.holiday &&
      formData.campaignType &&
      formData.sentimentType.length > 0
    ) {
      setRotatorLine(true);

      const data = {
        eventType: formData.eventType ? formData.eventType : "",
        campaignType: formData.campaignType ? formData.campaignType : "",
        holiday: formData.holiday ? formData.holiday : "",
        sentiment: formData.sentimentType ? formData.sentimentType : "",
        offerName: formData.offerName ? formData.offerName : "",
      };

      const PromoteCampaignRes = await PromoteCampaignAPI(data, () => {
        navigate("/");
      });
      if (PromoteCampaignRes.status === 200) {
        setIsCheck(true);
        setRotatorLine(false);
        setResponseGenerated(PromoteCampaignRes.data);
      } else if (PromoteCampaignRes.status === 429) {
        setLoading(true);
        swal({
          // title: "Error!",
          title: `${PromoteCampaignRes.message}`,
          icon: "error",
          buttons: "OK",
        });
      } else {
        setRotatorLine(false);
      }
    }
    // else {
    //   setIsCheck(false);
    // }

    setErrorLabelName((prevState) => ({
      ...prevState,
      eventType: formData.eventType === "" ? "Please select an event" : "",
      holiday: formData.holiday === "" ? "Please select a holiday" : "",
      campaignType:
        formData.campaignType === "" ? "Please select a campaign type" : "",
      sentiment:
        formData.sentimentType.length === 0
          ? "Please select a sentiment type"
          : "",
    }));
  };

  ////////////// function for selection and removal of dropdown items //////////////
  const handleInputChange = (selectedValue, flag) => {
    if (flag === "event_Type") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        eventType: selectedValue,
      }));
    } else if (flag === "holiday_Type") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        holiday: selectedValue,
      }));
    } else if (flag === "campaign_Type") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        campaignType: selectedValue,
      }));
    } else if (flag === "sentiment_Type") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        sentimentType: selectedValue,
      }));
    }
  };

  ////////////// validation for field inputs //////////////
  const handleChange = (e, flag) => {
    // setIsCheck(false)
    if (flag === "offer_name") {
      setFormData({
        ...formData,
        offerName: e.target.value,
      });
    }
  };

  ////////////// function to copy the response //////////////
  const CopyText = () => {
    const paragraphElement = document.getElementById("response-generated");
    if (paragraphElement) {
      const textToCopy = paragraphElement.innerText;
      navigator.clipboard.writeText(textToCopy);
      setCopyTextField(true);
      setTimeout(() => {
        setCopyTextField(false);
      }, 2000);
    }
  };

  ////////////// function to scroll down to the response once generated //////////////
  useEffect(() => {
    const copyButton = document.getElementById("copy-button");
    if (copyButton) {
      const buttonPosition =
        copyButton.getBoundingClientRect().top + window.scrollY;
      window.scrollTo(0, buttonPosition);
    }
  }, [responseGenerated]);

  return (
    <>
      {loading ? <Loader /> : null}
      <div className="shoplocalai-content-wrapper">
        <div className="shoplocalai-section-one">
          <img src={logo} alt="communityx logo" className="shop-local-logo"  style={{width:200}}/>
          <h2>
            <img
              src={subHeadingImage}
              alt="Subheading Image"
              className="subHeadingImage"
            />
            I WANT TO PROMOTE A CAMPAIGN
          </h2>
          <p className="bussiness-p_S text-center mt-1">
            This feature is to create attractive and inviting email content or
            social media content to showcase offers from your business members
            to end customers. To create email copy/social media content, select
            options and click on “Generate”. Copy the content generated, modify
            it as needed and use it in your email distribution application or in
            your social media channels. Sometimes the AI generated content may
            not be perfect to your needs, please review the information
            carefully.
          </p>
        </div>
        <div className="shoplocalai-section-two">
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label className="form-label-custom">
              Content Type<span className="star-required">* </span>
            </Form.Label>
            <InputGroup
              title={
                formData.eventType.length > 0
                  ? formData.eventType
                  : "Select for E-Mail content or Social Media Content"
              }
            >
              <Form.Group className="mb-0" controlId="formBasicEmail">
                <SelectDropdown
                  placeHolder="Select for E-Mail content or Social Media Content"
                  options={eventOptions}
                  inputValue={(selectedValue) => {
                    handleInputChange(selectedValue, "event_Type");
                  }}
                />
              </Form.Group>
            </InputGroup>
            <ErrorLabel ErrorDisplay={errorLabelName.eventType} />
          </Form.Group>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label className="form-label-custom">
              Holiday<span className="star-required">* </span>
            </Form.Label>
            <InputGroup
              title={
                formData.holiday.length > 0
                  ? formData.holiday
                  : "Select an option"
              }
            >
              <Form.Group className="mb-0" controlId="formBasicEmail">
                <SelectDropdown
                  placeHolder="Select an option"
                  options={holidayOptions}
                  inputValue={(selectedValue) => {
                    handleInputChange(selectedValue, "holiday_Type");
                  }}
                />
              </Form.Group>
            </InputGroup>
            <ErrorLabel ErrorDisplay={errorLabelName.holiday} />
          </Form.Group>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label className="form-label-custom">
              Campaign Type<span className="star-required">* </span>
            </Form.Label>
            <InputGroup
              title={
                formData.campaignType.length > 0
                  ? formData.campaignType
                  : "Select a campaign that is most relevant"
              }
            >
              <Form.Group className="mb-0" controlId="formBasicEmail">
                <SelectDropdown
                  placeHolder="Select a campaign that is most relevant"
                  options={campaignOptions}
                  inputValue={(selectedValue) => {
                    handleInputChange(selectedValue, "campaign_Type");
                  }}
                />
              </Form.Group>
            </InputGroup>
            <ErrorLabel ErrorDisplay={errorLabelName.campaignType} />
          </Form.Group>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label className="form-label-custom">
              Sentiment<span className="star-required">* </span>
            </Form.Label>
            <InputGroup
              title={
                formData.sentimentType.length > 0
                  ? formData.sentimentType
                  : "Select up to 3 sentiments"
              }
            >
              <Form.Group className="mb-0" controlId="formBasicEmail">
                <MultiSelectDropdown
                  maxOptions="3"
                  placeholder="Select up to 3 sentiments"
                  options={sentimentOptions}
                  inputValue={(selectedValue) => {
                    handleInputChange(selectedValue, "sentiment_Type");
                  }}
                />
              </Form.Group>
            </InputGroup>
            <ErrorLabel ErrorDisplay={errorLabelName.sentiment} />
          </Form.Group>
          <Form.Group
            className="mb-3 margin-bottom-medium"
            controlId="formBasicEmail"
          >
            <Form.Label className="form-label-custom">Offer Name</Form.Label>
            <InputGroup
              className="edit-border"
              title={
                formData.offerName.length > 0
                  ? formData.offerName
                  : "Enter specific offer title from the business"
              }
            >
              <Form.Control
                autoComplete="off"
                type="text"
                placeholder="Enter specific offer title from the business"
                className="custom-formcontrol"
                name="offer_name"
                value={formData.offerName}
                onChange={(e) => handleChange(e, "offer_name")}
              />
            </InputGroup>
          </Form.Group>
        </div>
        <div className="generator-div-wrapper">
          <div className="button-div description-button-wrapper">
            {rotatorLine ? (
              <button className="generate-response-button loader-button">
                <ThreeDots
                  style={{ position: "absolute" }}
                  height="10"
                  width="30"
                  radius="9"
                  color="white"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={true}
                />
              </button>
            ) : isCheck ? (
              <button className="regenerate-button" onClick={responseGenerator}>
                <img
                  loading="lazy"
                  src={regnerateIcon}
                  className="regnerateIcon"
                  alt="Regnerate Icon"
                />
                Regenerate
              </button>
            ) : (
              <button
                className="generate-response-button"
                onClick={responseGenerator}
              >
                Generate
              </button>
            )}
            <p className="toggling-content">
              (To avoid losing access, please copy the generated content before
              leaving the tab.)
            </p>
            {isCheck ? (
              <div className="response-section">
                <p
                  id="response-generated"
                  dangerouslySetInnerHTML={{ __html: responseGenerated }}
                />
                {responseGenerated ? (
                  <button onClick={CopyText} id="copy-button">
                    {copyTextField ? (
                      "Copied!"
                    ) : (
                      <>
                        <img
                          loading="lazy"
                          src={copyIcon}
                          alt="Copy Icon"
                          className="copyIcon"
                        />
                        Copy
                      </>
                    )}
                  </button>
                ) : (
                  <></>
                )}
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default PromoteCampaign;
